<template>
  <div class="user user__menu">
    <div class="photo">
      <img :src="avatar" alt="avatar" @error="setAltImg"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#">
           <span>
             {{title}}
             <b class="caret"></b>
          </span>
          <small>{{ designation }}</small> <br>
          <small>{{ roles.join(', ') }}</small>

      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav user-menu__nav" v-show="!isClosed">
            <slot>
              <li>
                <router-link to="/dashboard/profile" tag="a">
                  <span class="sidebar-mini-icon">MP</span>
                  <span class="sidebar-normal">My Profile</span>
                </router-link>
              </li>
              <li>
                <a href="#vue">
                  <span class="sidebar-mini-icon">S</span>
                  <span class="sidebar-normal">Settings</span>
                </a>
              </li>
              <li>
                <router-link to="/auth/logout" tag="a">
                  <span class="sidebar-mini-icon">L</span>
                  <span class="sidebar-normal">Logout</span>
                </router-link>
              </li>
            </slot>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'user-menu',
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: 'James Amos'
    },
    roles: {
      type: Array,
      default: () => []
    },
    image: {
      type: String
    },
    designation: String
  },
  computed: {
    avatar(){
      // let isStudent = this.roles.some((role) => role === 'student')
      if(this.image){ // if(isStudent)
        return this.image;
      }
      return `https://ui-avatars.com/api/?background=fff&color=0D8ABC&bold=true&size=128&name=${this.title}`;
    },
  },
  data() {
    return {
      isClosed: true
    };
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    setAltImg(event){
      event.target.src = `https://ui-avatars.com/api/?background=fff&color=0D8ABC&bold=true&size=128&name=${this.title}`
    }
  }
};
</script>
<style>
  .user__menu ul.user-menu__nav {
    margin-top: 0;
    padding-top: 10px;
  }

  .sidebar .user a, .off-canvas-sidebar .user a{
    padding: 0.25rem 15px;
  }

  .sidebar .user .photo, .off-canvas-sidebar .user .photo{
    width: 60px;
    height: 60px;
    margin-left: 10px;
    margin-right: 15px;
  }
</style>
